import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsExclusionRulesRoute: InvariantJiraRoute = {
	name: 'plan-settings-exclusion-rules',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules',
};
